export default __webpack_public_path__ + "static/media/public-icon-16.af687aa0.jpg";